import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import CreditControlUnitSummariesTable from "./components/CreditControlUnitSummariesTable";
import PageWrapper from "../shared/PageWrapper";
import { useParams } from "react-router-dom";

const CreditControlUnitPage: React.FC = () => {
  const { developmentID } = useParams();

  return (
    <CPLAnalytics pageName="Credit Control Unit">
      <PageWrapper
        data-test-id="credit-control-units-page__back-button"
        title="Credit Control Units"
        backTo={`/CreditControl/${developmentID}`}
      >
        <CreditControlUnitSummariesTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default CreditControlUnitPage;
